var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLeft = function SvgLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 96 96",
    height: 96,
    viewBox: "0 0 96 96",
    width: 96,
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M84 44H21.7l21.5-21.5c1.6-1.6 1.6-4.1 0-5.7 -1.6-1.6-4.1-1.6-5.7 0L9.2 45.2l0 0c-0.2 0.2-0.4 0.4-0.5 0.6 -0.1 0.1-0.1 0.2-0.2 0.3 -0.1 0.1-0.1 0.2-0.2 0.4 -0.1 0.1-0.1 0.3-0.1 0.4 0 0.1-0.1 0.2-0.1 0.3C8 47.5 8 47.7 8 48l0 0c0 0 0 0 0 0 0 0.3 0 0.5 0.1 0.8 0 0.1 0.1 0.2 0.1 0.3 0 0.1 0.1 0.3 0.1 0.4 0.1 0.1 0.1 0.3 0.2 0.4 0.1 0.1 0.1 0.2 0.2 0.3 0.1 0.2 0.3 0.4 0.5 0.6l28.3 28.3c1.6 1.6 4.1 1.6 5.7 0 1.6-1.6 1.6-4.1 0-5.7L21.7 52H84c2.2 0 4-1.8 4-4S86.2 44 84 44z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/left.a82323f3.svg";
export { ForwardRef as ReactComponent };